module.exports = __webpack_public_path__ + "img/4.37562b1d.jpg";